import React from 'react'
import { Card, Row, Col } from "react-bootstrap"
import { useTranslation } from "react-i18next";
import PropTypes from 'prop-types';
import moment from 'moment';

function MovementCard(props) {
    const { t } = useTranslation();
    //Parametros de entrada.
    const {
        inputParam_ElementItem = null,
    } = props;
    
    return (
        <>
            <Card style={{borderLeft: `10px solid ${ inputParam_ElementItem.color}`}}>
                    <Row className='px-1'>
                        <Col xl={12}>
                            <Row>
                                <Col>{t(inputParam_ElementItem.type)}</Col>
                                <Col className='col-auto me-auto'>{moment(inputParam_ElementItem.eventDate).format('DD/MM/YYYY')}</Col>
                            </Row>
                        </Col>
                        <Col xl={12} style={{fontSize: "12px"}}>{t(inputParam_ElementItem.text)}</Col>
                    </Row>
            </Card>
        </>
    );
}

///Proptypes
MovementCard.propTypes = {
    inputParam_ElementItem: PropTypes.object.isRequired,
};

export default MovementCard;